export default `query($nickName: String!, $siteId: String!, ) {
      getSellerID(nickName: $nickName, siteId: $siteId) {
        sellerId
      }
  }
`;